import * as yup from "yup";
import { FormValues } from "../interfaces/ApiResponse.interface";
import { phoneCheck } from '../../common/regex';
export const validationSchema: yup.ObjectSchema<FormValues> = yup.object({
  // Company Details
  FirstName: yup
    .string()
    .required("Company name is required")
    .matches(/^[A-Za-z\s]+$/, "Please enter your first name"),
  gstNumber: yup
    .string()
    .transform(value => value?.toUpperCase())
    .required("GST number is required")
    .matches(
      /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{1}Z[A-Z0-9]{1}$/,
      "Please enter a valid GST number"
    ),
  phoneNumber: yup
    .string()
    .required("Phone number is required")
    .matches(phoneCheck, "Please enter your valid phone number")
    .optional(),
  countryCode: yup.string(),
  dialCode: yup.string(),
  emailId: yup
    .string()
    .required("Email is required")
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      "Please enter your valid email address"
    ),
  address1: yup.string().required("Address Line 1 is required"),

  address2: yup.string().optional(),
  pincode: yup
    .string()
    .required("Pincode is required")
    .matches(/^[0-9]{6}$/, "please enter your Pincode "),
  state: yup.string().required("State is required"),
  city: yup.string().required("City is required"),
  country: yup.string().required("Country is required"), latitude: yup.number().nullable().required("Latitude is required"),
  longitude: yup.number().nullable().required("Longitude is required"),
  companyTypes: yup
    .array()
    .of(yup.string().required())
    .min(1, "At least one company type is required")
    .required("Company Types are required"),

  executiveDetails: yup
    .array()
    .of(
      yup.object().shape({
        firstName: yup.string().required("First Name is required"),
        lastName: yup.string().required("Last Name is required"),
        role: yup.string().required("Role is required"),
        phoneNumber: yup
          .string()
          .required("Phone number is required") // Ensure this is marked as required
          .matches(phoneCheck, "please enter your valid Phone number "), // Validate 10-digit phone number
        dialCode: yup.string(),
        emailId: yup
          .string()
          .required("Email is required")
          .matches(
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
            " Please enter your valid email address"
          ),
        prefix: yup.string().required("Prefix is required"),
      })
    )
    .min(1, "At least one executive is required")
    .required("Executive details are required"),

  // Payment Details
  paymentDetails: yup
    .array()
    .of(
      yup.object().shape({
        accountHolderName: yup
          .string()
          .optional()
          .nullable()
          .test(
            "is-valid-account-name",
            "Please enter a valid account name",
            (value) => !value || /^[A-Za-z\s]+$/.test(value)
          ),

        bankAccountNumber: yup
          .string()
          .optional()
          .nullable()
          .test(
            "is-valid-account-number",
            "Please enter a valid Account Number",
            (value) => !value || /^[0-9]+$/.test(value)
          ),

        ifscCode: yup
          .string()
          .optional()
          .nullable()
          .test(
            "is-valid-ifsc",
            "Please enter a valid IFSC code",
            (value) => !value || /^[A-Z]{4}0[A-Z0-9]{6}$/.test(value)
          ),

        bankName: yup.string().nullable().optional(),

        accountType: yup.string().nullable().optional(),

        upiNumber: yup
          .string()
          .optional()
          .nullable()
          .test(
            "is-valid-upi-number",
            "Please enter a valid UPI number",
            (value) => !value || phoneCheck.test(value)
          ),

        upiAddress: yup
          .string()
          .optional()
          .nullable()
          .test(
            "is-valid-upi-id",
            "Please enter a valid UPI ID",
            (value) => !value || /^[a-zA-Z0-9._-]+@[a-zA-Z]+$/.test(value)
          ),

        bankBranch: yup.string().nullable().optional(),
      })
    )
    .optional(),

  // Billing Address
  billingAddress: yup.object().shape({
    address1: yup.string().nullable(),
    address2: yup.string().nullable(),
    city: yup.string().nullable(),
    pincode: yup
      .string()
      .nullable()
      .test("is-valid-pincode", "Please enter a valid pincode", (value) => {
        return !value || /^[0-9]{6}$/.test(value); // Only validate if value exists
      }),
    state: yup.string().nullable(),
    country: yup.string().nullable(),
    phoneNumber: yup
      .string()
      .nullable()
      .test("is-valid-phone", "Please enter a valid phone number", (value) => {
        return !value || phoneCheck.test(value);
      }),
    dialCode: yup.string().nullable(),
    emailId: yup
      .string()
      .nullable()
      .test("is-valid-email", "Please enter a valid email address", (value) => {
        return !value || /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value);
      }),
  }),


  // Shipping Address
  shippingDetails: yup.array().of(
    yup.object().shape({
      address1: yup.string().nullable(),
      address2: yup.string().nullable(),
      city: yup.string().nullable(),
      pincode: yup
        .string()
        .nullable()
        .test("is-valid-pincode", "Please enter a valid pincode", (value) => {
          return !value || /^[0-9]{6}$/.test(value); // Only validate if value exists
        }),
      state: yup.string().nullable(),
      country: yup.string().nullable(),
      phoneNumber: yup
        .string()
        .nullable()
        .test("is-valid-phone", "Please enter a valid phone number", (value) => {
          return !value || phoneCheck.test(value);
        }),
      emailId: yup
        .string()
        .nullable()
        .test("is-valid-email", "Please enter a valid email address", (value) => {
          return !value || /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value);
        }),
    })
  ),
});